import { RetailBrands } from '@lentau/ui-kit/core/tokens/constants';

/** Переопределения X-Retail-Brand; остальным — appBrand as-is */
export const RETAIL_BRAND_HEADER_BY_APP_BRAND: ReadonlyMap<RetailBrands, RetailBrands> = new Map<
  RetailBrands,
  RetailBrands
>([[RetailBrands.UTKONOS, RetailBrands.LENTA_ONLINE]]);

export const getRetailBrandHeader: (appBrand: RetailBrands) => RetailBrands = (
  appBrand: RetailBrands
): RetailBrands => RETAIL_BRAND_HEADER_BY_APP_BRAND.get(appBrand) ?? appBrand;
